"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _actions = require("./actions");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var translateY = function translateY(props) {
  return props.isOpen ? 0 : "110%";
};

var StyledWrapper = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 6;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  padding: ", ";\n\n  box-shadow: 0px -4px 15px ", ";\n  background: ", ";\n  color: ", ";\n  opacity: ", ";\n  transform: translateY(", ");\n  transition-property: transform, opacity;\n  transition-duration: 0.45s;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  @media (min-width: ", ") {\n    left: 50%;\n    width: ", ";\n    margin: 0 auto;\n    bottom: 0;\n    transform: translateY(", ") translateX(-50%);\n  }\n"])), function (props) {
  return props.hasLogoBottombar ? "2.5rem 1rem 3.5rem" : "1.5rem 1rem";
}, (0, _polished.rgba)("black", 0.08), function (props) {
  return props.theme.colorSuccess;
}, function (p) {
  return p.theme.colorSuccessText;
}, function (props) {
  return props.isOpen ? 1 : 0;
}, function (p) {
  return translateY(p);
}, function (props) {
  return props.theme.screenWidthMd;
}, function (props) {
  return props.theme.railWidth;
}, function (p) {
  return translateY(p);
});

var StyledButton = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  justify-content: center;\n  background: ", ";\n  color: ", ";\n  border: 4px solid ", ";\n  border-radius: 2rem;\n  width: 85%;\n  height: 4rem;\n  max-width: 290px;\n  white-space: nowrap;\n  font-size: 1.5rem;\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n"])), function (p) {
  return p.theme.colorSuccessText;
}, function (p) {
  return p.theme.colorSuccess;
}, function (props) {
  return props.theme.colorSuccessText;
}, function (props) {
  return props.isLoading ? 0 : "0 1rem 0 0";
});

var StyledMatIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 44px;\n"])));

var StyledText = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 1;\n  text-align: center;\n  padding: 0 1rem 0 2rem;\n"])));

var StyledSmallPrint = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 0.6375rem;\n"])));

var StyledSpinner = (0, _styledComponents.default)(_fiverReactUiComponents.Spinner)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  border-color: ", ";\n  border-top-color: ", ";\n"])), function (p) {
  return (0, _polished.rgba)(p.theme.colorSuccess, 0.15);
}, function (p) {
  return p.theme.colorSuccess;
});

var ContestBetNow = function ContestBetNow(_ref) {
  var setBetbarParent = _ref.setBetbarParent,
      isOpen = _ref.isOpen,
      isLoading = _ref.isLoading,
      onPlaceBetClicked = _ref.onPlaceBetClicked,
      betbarParent = _ref.betbarParent,
      consentCheckboxes = _ref.consentCheckboxes;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.contest;
  }),
      picks = _useSelector.picks,
      translations = _useSelector.translations;

  var activePickem = betbarParent.activePickem;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper // onClick={() =>
  //   placeBet(translations, setBetbarParent, activePickem?.id, picks)
  // }
  , {
    onClick: function onClick() {
      return onPlaceBetClicked(picks, consentCheckboxes === null || consentCheckboxes === void 0 ? void 0 : consentCheckboxes.marketing);
    },
    isOpen: isOpen,
    hasLogoBottombar: process.env.REACT_APP_NAV_ICON,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButton, {
      isLoading: isLoading,
      children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSpinner, {
        forDark: false,
        lineWidth: 6
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
          children: (activePickem === null || activePickem === void 0 ? void 0 : activePickem.stake) > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: ["Place \xA3", /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.PenceToPounds, {
              children: activePickem === null || activePickem === void 0 ? void 0 : activePickem.stake
            }), " ", "Bet"]
          }) : translations.submitPicks
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMatIcon, {
          children: "chevron_right"
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSmallPrint, {
      children: translations.submitPicksSmallPrint
    })]
  });
};

var _default = ContestBetNow;
exports.default = _default;